var React = require('react');

function ArrowRightSkinny (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.2424 4.85355C29.4377 4.65829 29.4377 4.34171 29.2424 4.14645L26.0605 0.964466C25.8652 0.769204 25.5486 0.769204 25.3534 0.964466C25.1581 1.15973 25.1581 1.47631 25.3534 1.67157L28.1818 4.5L25.3534 7.32843C25.1581 7.52369 25.1581 7.84027 25.3534 8.03553C25.5486 8.2308 25.8652 8.2308 26.0605 8.03553L29.2424 4.85355ZM0 4.5V5H28.8889V4.5V4H0V4.5Z"}));
}

ArrowRightSkinny.defaultProps = {"width":"30","height":"9","viewBox":"0 0 30 9","fill":"currentColor"};

module.exports = ArrowRightSkinny;

ArrowRightSkinny.default = ArrowRightSkinny;
